const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const generateValues = item => {
  if (item.attribute_key === 'content') {
    const values = item.values || '';
    
    // Para operadores que esperam valor único exato (match completo)
    // Não fazer split por vírgula - tratar como texto único
    if (['equal_to', 'not_equal_to', 'starts_with'].includes(item.filter_operator)) {
      return [values];
    }
    
    // Para operadores que podem aceitar múltiplos valores (contains, does_not_contain)
    // Fazer split por vírgula e trim para permitir múltiplas palavras-chave
    // Exemplo: "oi, olá, bom dia" -> ["oi", "olá", "bom dia"]
    if (['contains', 'does_not_contain'].includes(item.filter_operator)) {
      return values.split(',').map(v => v.trim()).filter(v => v.length > 0);
    }
    
    // Default: trata como valor único para operadores desconhecidos
    return [values];
  }
  
  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }
  if (typeof item.values === 'object') {
    return [item.values.id];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    item.values = generateValues(item);
    return item;
  });

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;